import { SIZE } from '@app/constants'

import type { TablePaginationConfig } from 'antd'

export const defaultPagination: TablePaginationConfig = {
  showTotal: (total: number): string => `К-во записей: ${total}`,
  pageSizeOptions: [10, 50, 100, 500, 1000],
  showSizeChanger: true,
  size: SIZE.small
}
